import React from 'react'
import styled, {css, keyframes} from 'styled-components'
import Link from 'gatsby-link'
import to from "gatsby-link";
import presets from "../utils/presets"
import {rhythm} from "../utils/typography"

const Cta = styled(Link)`
  display: inline-block;
  position:relative;
  padding: ${rhythm(0.4)} ${rhythm(0.5)};
  background-color: ${presets.brand};
  font-family: ${presets.brandFontFamily};
  text-transform: uppercase;
  line-height: 1;
  margin-bottom:${rhythm(1)};
  ::before{content:"";}
  ::after{content:"";}
  ${presets.shadowMed}
  :hover{
    ${presets.shadowLow}
    background-color: ${presets.brand};
  }
`
export default(props) => {
  return(
    <Cta to={props.to}>{props.children}</Cta>
  );
}



// WEBPACK FOOTER //
// ./src/com/Cta.js